import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-data-block',
  imports: [CommonModule],
  templateUrl: './data-block.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './data-block.component.scss',
})
export class DataBlockComponent {
  compact = input(false);
}
